import * as React from 'react'
import IconPanel from '@mulesoft/anypoint-icons/lib/Icon'
import Button from '@mulesoft/anypoint-components/lib/Button'
import './LogPointsTopBar.css'

export type ValueProps = {
  hasSavedYet: boolean
  hasChanges: boolean
  isSaving: boolean
  disabledButton?: boolean
  error?: any
  applicationName?: string
}

export type EventProps = {
  saveChanges: () => void
}

export type Props = ValueProps & EventProps

const savingButtonMessage = 'Saving'
const savedButtonMessage = 'Saved'
const saveAndApplyButtonMessage = 'Save & Apply'

const getTopBarButtonText = (props: Props): string => {
  const {hasSavedYet, hasChanges, isSaving} = props

  if (isSaving) return savingButtonMessage
  else if (!hasChanges && hasSavedYet) return savedButtonMessage
  else return saveAndApplyButtonMessage
}

export const LogPointsTopBarButton = (props: Props) => {
  const {hasChanges, isSaving, disabledButton, error, hasSavedYet, saveChanges} = props

  const buttonText = getTopBarButtonText(props)
  const isButtonDisabled = disabledButton ? true : hasChanges ? isSaving : true
  const isSaved = hasSavedYet && !error && !hasChanges && !isSaving

  return (
    <Button
      kind="primary"
      disabled={isButtonDisabled}
      isLoading={isSaving}
      onClick={saveChanges}
      testId={'log-points-save-apply-button'}
    >
      {isSaved &&
      <IconPanel className="log-points-page-top-bar-button-icon" name="check-small" testId={'log-points-page-top-bar-button-icon'} size={18}/>
      }
      {buttonText}
    </Button>
  )
}